<template>
  <div class="defect-input">
    <div class="form-group row">
      <label
        :for="options.name"
        :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'"
      >
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <div class="upload-btn-wrapper" id="dropzone">
          <button class="btn btn-info upload-button" type="button">
            <i class="fa fa-plus"></i> Upload Defects
          </button>
          <br />
          <span class="text-muted"
            >This will create a new defect for each image selected.</span
          >
          <input
            type="hidden"
            :name="options.name"
            :id="options.name + '-url'"
            :value="value"
          />
        </div>
        <div v-if="hasError" class="alert alert-danger my-0">
          {{ hasError }}
        </div>
        <div class="progress" style="height: 20px;" v-show="isUploading">
          <div
            class="progress-bar progress-bar-striped progress-bar-animated"
            role="progressbar"
            :style="{ width: progress + '%' }"
          >
            {{ progress }}%
          </div>
        </div>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <div class="toolbar text-right mb-3">
          <button
            v-if="value.length"
            type="button"
            class="mt-1 btn btn-secondary"
            @click="toggleAll()"
          >
            <i
              class="fa"
              :class="expandAccordians ? 'fa-chevron-up' : 'fa-chevron-down'"
            ></i>
            All
          </button>
          <button
            type="button"
            class="mt-1 btn btn-indigo"
            @click="newDefect()"
          >
            <i class="fa fa-plus"></i> New Defect
          </button>
          <button
            type="button"
            class="mt-1 btn btn-primary"
            @click="newHeading()"
          >
            <i class="fa fa-plus"></i> New Heading
          </button>
        </div>
        <draggable v-model="valArray" @end="validate(valArray)">
          <div v-for="(val, index) in valArray" :key="index">
            <div class="card mb-3">
              <accordian-display
                ref="accordians"
                :defaultOpen="true"
                :draggable="true"
                :title="
                  val.textOnly ? val.description : 'Item ' + parseInt(index + 1)
                "
                :icon="
                  val.textOnly ? 'fa fa-fw fa-heading' : 'fa fa-fw fa-table'
                "
              >
                <div class="card-body text-dark">
                  <text-input
                    v-if="val.textOnly"
                    v-model="val.description"
                    :options="{
                      label: 'Heading',
                      name: 'description',
                      value: val.description,
                      fullWidth: true
                    }"
                  >
                  </text-input>
                  <div class="row" v-else>
                    <div class="col-md-7 my-1 text-center">
                      <div
                        class="tfm-textarea"
                        @click="openTextEditor(val, index)"
                        v-html="val.description"
                      ></div>
                    </div>
                    <div class="col-md-5 my-1">
                      <defects-amazon-media-multiple-input
                        ref="uploaders"
                        v-model="val.images"
                        :options="{
                          validFileType: 'image',
                          index: (Math.random() + 1).toString(36).substring(7),
                          width: 800,
                          draggable: true,
                          displayImages: true,
                          label: 'Images',
                          name: 'images',
                          value: val.images,
                          fullWidth: true
                        }"
                      >
                      </defects-amazon-media-multiple-input>
                    </div>
                  </div>
                </div>
              </accordian-display>
              <div class="card-footer text-right">
                <button
                  @click.prevent="deleteImage(val)"
                  class="my-1 btn btn-danger"
                >
                  <i class="fa fa-trash"></i> Remove
                </button>
              </div>
            </div>
          </div>
        </draggable>
        <div v-if="value.length" class="toolbar text-right">
          <button
            type="button"
            class="mt-1 btn btn-secondary"
            @click="toggleAll()"
          >
            <i class="fa fa-chevron-up"></i> All
          </button>
          <button
            type="button"
            class="mt-1 btn btn-indigo"
            @click="newDefect()"
          >
            <i class="fa fa-plus"></i> New Defect
          </button>
          <button
            type="button"
            class="mt-1 btn btn-primary"
            @click="newHeading()"
          >
            <i class="fa fa-plus"></i> New Heading
          </button>
        </div>
      </div>
    </div>
      <!-- Add confirmation modal -->
      <modal
      v-if="showDeleteConfirmation"
      title="Confirm Delete"
      :is-open="showDeleteConfirmation"
      @dismiss="cancelDelete()"
    >
      <div class="text-strong mb-0">
          <h6>Are you sure you want to delete this item?</h6>
      </div>
      <div slot="footer" class="text-right">
        <button type="button" class="btn btn-secondary mr-2" @click="cancelDelete()">
          Cancel
        </button>
        <button type="button" class="btn btn-danger" @click="executeDelete()">
          Delete
        </button>
      </div>
    </modal>
    <div class="modal-backdrop fade show" v-show="showDeleteConfirmation"></div>

    <modal
      v-if="editingText"
      :title="'Edit Description'"
      :is-open="editingText"
      @dismiss="closeModal()"
    >
      <rich-text-input :options="editorOpts" v-model="editorOpts.value">
      </rich-text-input>
      <div slot="footer">
        <button type="button" class="btn btn-success" @click="closeModal()">
          Done
        </button>
      </div>
    </modal>
    <div class="modal-backdrop fade show" v-show="editingText"></div>
  </div>
</template>

<script>
import AccordianDisplay from "@/components/displays/AccordianDisplay";
import Draggable from "vuedraggable";
import { OPEN_MODAL, CLOSE_MODAL, COMPONENT_METHOD } from "@/vuex/types";
import Modal from "@/components/ui/Modal";
import RichTextInput from "@/components/inputs/RichTextInput";
import TextInput from "@/components/inputs/TextInput";
import DefectsAmazonMediaMultipleInput from "@/components/inputs/DefectsAmazonMediaMultipleInput";
import {
  validationClass,
  validationIcon,
  validationMessage
} from "@/util/helpers";

export default {
  name: "DefectInput",
  props: {
    value: {
      type: Array
    },
    options: {
      type: Object,
      default() {
        return {
          valid: false,
          dirty: false
        };
      }
    }
  },
  components: {
    AccordianDisplay,
    DefectsAmazonMediaMultipleInput,
    Modal,
    Draggable,
    RichTextInput,
    TextInput
  },
  data() {
    return {
      expandAccordians: true,
      editorOpts: {},
      progress: 0,
      editingText: false,
      isUploading: false,
      isDirty: false,
      isValid: false,
      hasError: false,
      valArray: [],
      showDeleteConfirmation: false,
      itemToDelete: null,
      indexToDelete: null,
      fileTypes: {
        image: /^(image\/(gif|jpe?g|png))$/,
        pdf: /^(application\/(pdf|x-pdf|acrobat))|(text\/(pdf|x-pdf))|(applications\/vnd\.pdf)$/
      },
      validFileType: /^(image\/(gif|jpe?g|png))|(application\/(pdf|x-pdf|acrobat))|(text\/(pdf|x-pdf))|(applications\/vnd\.pdf)$/,
      invalidFileTypeError:
        "Not an accepted file type. Accepted file types: JPG, PNG, GIF and PDF"
    };
  },
  computed: {
    height() {
      return this.options.height || "auto";
    },
    width() {
      return this.options.width || "auto";
    },
    validationClass,
    validationIcon,
    validationMessage
  },
  mounted() {
    this.valArray = this.value;
    if (this.options.validFileType === "image") {
      this.validFileType = this.fileTypes.image;
      this.invalidFileTypeError =
        "You must upload an image file. Accepted file types: JPG, PNG and GIF";
    } else if (this.options.validFileType === "pdf") {
      this.validFileType = this.fileTypes.pdf;
      this.invalidFileTypeError = "You must upload a PDF file.";
    }
    if (this.options.text === false) this.hasText = false;
    window.fd.logging = false;
    let zone = new window.FileDrop("dropzone", {
      iframe: {
        url: `/api/admin/media-uploader?height=${this.height}&width=${this.width}`,
        fileParam: "media",
        callbackParam: "iframeCallback"
      }
    });
    zone.multiple(true);
    let fileName = "";
    let $vm = this;
    zone.event("send", function(files) {
      $vm.isUploading = true;
      files.each(function(file) {
        fileName = file.name;
        $vm.hasError = false;
        let uploadErrors = [];
        let acceptFileTypes = $vm.validFileType;
        if (file.type.length && !acceptFileTypes.test(file.type)) {
          uploadErrors.push($vm.invalidFileTypeError);
        }
        if (file.size.length && file.size > 10000000) {
          uploadErrors.push("Filesize is too big");
        }
        if (uploadErrors.length > 0) {
          $vm.progress = 0;
          $vm.isUploading = false;
          $vm.hasError = uploadErrors.join("\n");
        } else {
          file.event("progress", function(sent, total, xhr, event) {
            $vm.progress = parseInt((sent / total) * 100, 10);
          });
          file.event("done", function(xhr) {
            $vm.progress = 0;
            $vm.isUploading = false;
            let values = $vm.value;
            let json = JSON.parse(xhr.responseText);
            values.push({
              images: [
                {
                  key: json.key,
                  fileName,
                  fileType: json.ext
                }
              ],
              description: `
                  <div style="text-align:justify;"><strong><u>Location:</u></strong><br />
                  <br />
                  <br />
                  <strong><u>Finding:</u></strong><br />
                  <br />
                  <br />
                  <strong><u>Recommendations:</u></strong><br />
                  <br />
                  </div>
                  `
            });
            $vm.$emit("input", values);
          });
          file.event("error", function(xhr) {
            uploadErrors.push(xhr.responseText);
            $vm.hasError = uploadErrors.join("\n");
          });
          file.sendTo(
            `/api/admin/media-uploader?height=${$vm.height}&width=${$vm.width}`,
            {
              extraHeaders: true,
              method: "POST"
            }
          );
        }
      });
    });
    zone.event("iframeDone", function(json) {
      $vm.progress = 0;
      $vm.isUploading = false;
      let values = $vm.value;
      values.push({
        images: [
          {
            key: json.key,
            fileName,
            fileType: json.ext
          }
        ],
        description: `
            <div style="text-align:justify; line-height: 1.15;"><strong><u>Location:</u></strong></div>
            <div style="text-align:justify; line-height: 1.15;"><strong><u>Finding:</u></strong></div>
            <div style="text-align:justify; line-height: 1.15;"><strong><u>Recommendations:</u></strong></div>
            `
      });
      $vm.$emit("input", values);
    });
    window.fd.addEvent(window.fd.byID("multiple"), "change", function(e) {
      zone.multiple(e.currentTarget || e.srcElement.checked);
    });
    this.validate(this.value);
  },
  methods: {
    toggleAll() {
      let method = "close";
      if (!this.expandAccordians) method = "open";
      this.$store.dispatch(COMPONENT_METHOD, {
        method,
        payload: this.$refs.accordians
      });
      this.expandAccordians = !this.expandAccordians;
    },
    newDefect() {
      this.expandAccordians = true;
      let value = this.value;
      value.push({
        images: [],
        description: `
            <div style="text-align:justify; line-height: 1.15;"><strong><u>Location:</u></strong></div>
            <div style="text-align:justify; line-height: 1.15;"><strong><u>Finding:</u></strong></div>
            <div style="text-align:justify; line-height: 1.15;"><strong><u>Recommendations:</u></strong></div>
            `
      });
    },
    newHeading() {
      this.expandAccordians = true;
      let value = this.value;
      value.push({
        textOnly: true,
        description: ""
      });
    },
    validate(val = this.value) {
      if (this.$refs.uploaders) {
        for (let upl of this.$refs.uploaders) {
          upl.valArray = upl.value;
        }
      }
      this.$emit("input", val);
      this.isDirty = true;
      if (Array.isArray(val) && val.length) {
        this.isValid = true;
      } else if (this.options.required) {
        this.isValid = false;
      } else {
        this.isValid = true;
      }
    },
    deleteImage(image) {
      this.confirmDelete(image, this.value.indexOf(image));
    },
    openTextEditor(val, index) {
      this.editorOpts = {
        index,
        name: "textEditor",
        fullWidth: true,
        value: val.description
      };
      this.editingText = true;
      this.$store.dispatch(OPEN_MODAL, {
        title: "Edit Description",
        alreadyOpen: true
      });
    },
    confirmDelete(val, index) {
      this.itemToDelete = val;
      this.indexToDelete = index;
      this.showDeleteConfirmation = true;
      this.$store.dispatch(OPEN_MODAL, {
        title: "Confirm Delete",
        alreadyOpen: true
      });
    },

    cancelDelete() {
      this.showDeleteConfirmation = false;
      this.itemToDelete = null;
      this.indexToDelete = null;
      this.$store.commit(CLOSE_MODAL, 0);
    },

    executeDelete() {
      let values = this.value;
      values.splice(this.indexToDelete, 1);
      this.$emit("input", values);
      this.showDeleteConfirmation = false;
      this.itemToDelete = null;
      this.indexToDelete = null;
      this.$store.commit(CLOSE_MODAL, 0);
    },
    async closeModal() {
      tinymce.triggerSave();
      let newDescription = tinymce.activeEditor.getContent({ format: "raw" });
      await this.$nextTick();
      let values = this.value;
      values[this.editorOpts.index].description = newDescription;
      this.$emit("input", values);
      this.editingText = false;
      this.$store.commit(CLOSE_MODAL, 0);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/inputs/DefectInput.vue